import Vue from "vue";
import Vuelidate from "vuelidate";
import VueGtm from "vue-gtm";
import axios from "axios";
import TextInput from "@/components/ui/TextInput.vue";
import NumberInput from "@/components/ui/NumberInput.vue";
import SSNInput from "@/components/ui/SSNInput.vue";
import DatePicker from "@/components/ui/DatePicker.vue";
import Inputmask from "@/helpers/inputmask";
import PrivateLabelLoader from "@/config/PrivateLabelLoader";
import EnvironmentBanner from "@/plugins/environment-banner/environment-banner";
import HeadTitle from "@/components/HeadTitle.vue";
import AppWrapper from "./AppWrapper.vue";
import store from "./store";
import router from "./router";

import "flatpickr/dist/flatpickr.css";

Vue.component("HeadTitle", HeadTitle);
Vue.component("TextInput", TextInput);
Vue.component("NumberInput", NumberInput);
Vue.component("SSNInput", SSNInput);
Vue.component("DatePicker", DatePicker);
Vue.directive("inputmask", Inputmask);
Vue.use(Vuelidate);

Vue.use(PrivateLabelLoader);
Vue.use(VueGtm, {
  enabled: !!process.env.VUE_APP_GTM_ID, // GTM scripts are only injected if the gtm_id exists
  id: process.env.VUE_APP_GTM_ID,
  debug: false, // console.logs every action
  ignoredViews: [],
});
Vue.use(EnvironmentBanner);

Vue.prototype.$axios = axios.create({ withCredentials: true });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(AppWrapper),
}).$mount("#app");
